import React from 'react';
import { connect } from 'react-redux';
import { withRouter , Link} from 'react-router';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import Modal from 'react-modal';
// import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as UserActions from '../../../actions/user_actions';
import * as QuestionnaireActions from '../../../actions/questionnaire_actions';
import Header from '../../../components/header';
let screenIdentifier = 'AddOptionalQuestion';
import _ from 'lodash';


export var AddOptionalQuestions = React.createClass({
    getInitialState() {
        return {
            //update Question tModal
            conformationModalMessage: null,
            showModal: false,
            UpdateButton: false, isQuestionSelected: false,

            publishedQuestions: [],
            linkedQuestions: [],
        }
    },
    componentWillMount() {
        let patientId = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        let facilitiesID = this.props.UserData.selectdUserFacilityID;
        this.props.Dispatch(QuestionnaireActions.adminGetAllUniqueQuestion(patientId + '/' + facilitiesID));

    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.uniqe && nextProps.uniqe.data) {
            if (nextProps.uniqe.data.publishedQuestions && nextProps.uniqe.data.publishedQuestions.length) {
                this.setState({ publishedQuestions: nextProps.uniqe.data.publishedQuestions });
                this.setState({ UpdateButton: true });
            }

            if (nextProps.uniqe.data.linkedQuestions && nextProps.uniqe.data.linkedQuestions.length) {
                this.setState({ linkedQuestions: nextProps.uniqe.data.linkedQuestions });
                this.setState({ UpdateButton: true });
            }
        }


    },
    removeUpdate() {
        this.setState({
            isUpdate: false
        })
    },
    publishQuestionSelectedId(e, button) {

        this.state.isQuestionSelected ? "" : this.setState({ isQuestionSelected: true });
        if(e.target.className ==="icon-tick"){
          return false;
        }
        var isAlreadyExists = [];

        // if User clicked on tick-mark icon
        if (e.target.className == 'icon-tick') {
            isAlreadyExists = this.props.publishQuestionSelected && _.filter(this.props.publishQuestionSelected, function (item) {
                return item.id === e.target.parentElement.dataset.value;
            });

            // to make it select(green)
            if (e.target.parentElement.className == 'tickmark') {
                e.target.parentElement.className = 'tickmark tickmark-after';

                if (isAlreadyExists.length > 0) {
                    for (let i = 0; i < this.props.publishQuestionSelected.length; i++) {
                        if (this.props.publishQuestionSelected[i].id === e.target.parentElement.dataset.value) {
                            this.props.publishQuestionSelected.pop({ "id": e.target.parentElement.dataset.value });
                        }
                    }
                }
                else {
                    this.props.publishQuestionSelected.push({ "id": e.target.parentElement.dataset.value });
                }
            }
            // To make it deSelect(grey)
            else {
                e.target.parentElement.className = 'tickmark'
                if (isAlreadyExists.length > 0) {
                    for (let i = 0; i < this.props.publishQuestionSelected.length; i++) {
                        if (this.props.publishQuestionSelected[i].id === e.target.parentElement.dataset.value) {
                            this.props.publishQuestionSelected.pop({ "id": e.target.parentElement.dataset.value });
                        }
                    }
                }
                else {
                    this.props.publishQuestionSelected.push({ "id": e.target.parentElement.dataset.value });
                }
                e.stopPropagation();
            }

            return;
        }

        // if User clicked on tick-mark icon background
        // to make it selected(Green)
        if (e.target.className == 'tickmark') {
            isAlreadyExists = this.props.publishQuestionSelected && _.filter(this.props.publishQuestionSelected, function (item) {
                return item.id === e.target.dataset.value;
            });
            e.target.className = 'tickmark tickmark-after';
            if (isAlreadyExists.length > 0) {
                for (let i = 0; i < this.props.publishQuestionSelected.length; i++) {
                    if (this.props.publishQuestionSelected[i].id === e.target.dataset.value) {
                        this.props.publishQuestionSelected.pop({ "id": e.target.dataset.value });
                    }
                }
            }
            else {
                this.props.publishQuestionSelected.push({ "id": e.target.dataset.value });
            }


        }
        // To make it deselect(grey)
        else {
            e.target.className = 'tickmark'
            isAlreadyExists = this.props.publishQuestionSelected && _.filter(this.props.publishQuestionSelected, function (item) {
                return item.id === e.target.dataset.value;
            });
            if (isAlreadyExists.length > 0) {
                for (let i = 0; i < this.props.publishQuestionSelected.length; i++) {
                    if (this.props.publishQuestionSelected[i].id === e.target.dataset.value) {
                        this.props.publishQuestionSelected.pop({ "id": e.target.dataset.value });
                    }
                }
            }
            else {
                this.props.publishQuestionSelected.push({ "id": e.target.dataset.value });
            }
            e.stopPropagation();
        }
        return;
    },
    removeQuestions(e, button) {

        var isAlreadyExists = [];
        this.state.isQuestionSelected ? "" : this.setState({ isQuestionSelected: true });
        // if User clicked on tick-mark icon
        if (e.target.className == 'icon-tick') {
            isAlreadyExists = this.props.publishQuestionSelected && _.filter(this.props.publishQuestionSelected, function (item) {
                return item.id === e.target.parentElement.dataset.value;
            });

            // to make it select(green)
            if (e.target.parentElement.className == 'tickmark') {
                e.target.parentElement.className = 'tickmark tickmark-after';

                if (isAlreadyExists.length > 0) {
                    for (let i = 0; i < this.props.RemovedPublishedQuestion.length; i++) {
                        if (this.props.RemovedPublishedQuestion[i].id === e.target.parentElement.dataset.value) {
                            this.props.RemovedPublishedQuestion.pop({ "id": e.target.parentElement.dataset.value });
                        }
                    }
                }
                else {
                    this.props.RemovedPublishedQuestion.push({ "id": e.target.parentElement.dataset.value });
                }
            }
            // To make it deSelect(grey)
            else {
                e.target.parentElement.className = 'tickmark'
                if (isAlreadyExists.length > 0) {
                    for (let i = 0; i < this.props.RemovedPublishedQuestion.length; i++) {
                        if (this.props.RemovedPublishedQuestion[i].id === e.target.parentElement.dataset.value) {
                            this.props.RemovedPublishedQuestion.pop({ "id": e.target.parentElement.dataset.value });
                        }
                    }
                }
                else {
                    this.props.RemovedPublishedQuestion.push({ "id": e.target.parentElement.dataset.value });
                }
                e.stopPropagation();
            }

            return;
        }

        // if User clicked on tick-mark icon background
        // to make it selected(Green)
        if (e.target.className == 'tickmark') {
            isAlreadyExists = this.props.RemovedPublishedQuestion && _.filter(this.props.RemovedPublishedQuestion, function (item) {
                return item.id === e.target.dataset.value;
            });
            e.target.className = 'tickmark tickmark-after';
            if (isAlreadyExists.length > 0) {
                for (let i = 0; i < this.props.RemovedPublishedQuestion.length; i++) {
                    if (this.props.RemovedPublishedQuestion[i].id === e.target.dataset.value) {
                        this.props.RemovedPublishedQuestion.pop({ "id": e.target.dataset.value });
                    }
                }
            }
            else {
                this.props.RemovedPublishedQuestion.push({ "id": e.target.dataset.value });
            }


        }
        // To make it deselect(grey)
        else {
            e.target.className = 'tickmark'
            isAlreadyExists = this.props.RemovedPublishedQuestion && _.filter(this.props.RemovedPublishedQuestion, function (item) {
                return item.id === e.target.dataset.value;
            });
            if (isAlreadyExists.length > 0) {
                for (let i = 0; i < this.props.RemovedPublishedQuestion.length; i++) {
                    if (this.props.RemovedPublishedQuestion[i].id === e.target.dataset.value) {
                        this.props.RemovedPublishedQuestion.pop({ "id": e.target.dataset.value });
                    }
                }
            }
            else {
                this.props.RemovedPublishedQuestion.push({ "id": e.target.dataset.value });
            }
            e.stopPropagation();
        }
        return;
    },
    onConfirm() {
        //  Publish  Question
         
        var data = { "user": { "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.id }, "doctor": { "id": this.props.UserData.loginData.data.id }, "facility": { "id": this.props.UserData.selectdUserFacilityID }, "questions": this.props.publishQuestionSelected, "removedQuestions": this.props.RemovedPublishedQuestion };
        this.props.Dispatch(UserActions.questionUpdateSurvey(data));
        this.setState({ conformationModalMessage: null, isQuestionSelected: false });

    },
    publishQuestion() {

      //  if ((this.props.publishQuestionSelected.length > 0) || (this.props.RemovedPublishedQuestion.length > 0)) {
        if(true){
            this.setState({
                conformationModalMessage: "Are you sure you want to add/remove optional question(s) to patient's daily survey?",
            });
        }
         // else {
        //     this.setState({ showModal: "Select at least 1 Question(s) to update." });
        // }
        //

    },
    closebox() {
        this.setState({ showModal: false, modal: false, conformationModalMessage: null });
    },
    render() {

        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} breadcrumb={true}/>
                <div className="breadcrumb-custom">
                  <h2> <Link to="/patients">PATIENTS</Link> > <a onClick={this.props.router.goBack} >{this.props.FacilitiesDetails.FaciliteAdminUser.data.firstName}</a> > OPTIONAL QUESTION(S)</h2>
                </div>
                <div className="white-box">
                    {
                        this.state.UpdateButton && this.state.isQuestionSelected &&
                        <button className="gray-button Question-upadte" data-toggle="modal" data-target="update" onClick={this.publishQuestion}>Update Survey</button>
                    }

                    {this.state.publishedQuestions && this.state.publishedQuestions.length == 0 &&  this.state.linkedQuestions &&  this.state.linkedQuestions.length == 0  ? <p>No optional questions found.</p> : ""
                    }
                    <div role="tabpanel" className="tab-pane active">
                        {_.map(this.state.publishedQuestions && this.state.publishedQuestions, (v, i) => {
                            if (this.state.editQuestion && this.state.editQuestion.id === v.id) {
                                return
                            }
                            return <div key={i} className="input-group input-field your-question">
                                <div className="addingQuestions">
                                    <div className="ques-edit pull-right">

                                    </div>

                                    <div className='tickmark' onClick={this.publishQuestionSelectedId} data-value={v.id} >
                                        <span className="icon-tick"></span>
                                    </div>
                                    <div className="yourquestion saved-ques" >
                                        <div >
                                            <p>{v.name}</p>
                                            <ul className="increment-questions">
                                                <li className="ques-gray">{v.answerType.type}</li>
                                            </ul>
                                            {v.answerType.id.toString() !== '7' && _.map(v.answer, (v1, i) => {
                                                return <div className="padding-left-30" key={i}>
                                                    <p><span className="icon-add-more"></span><span className="followtext">{v1.name}</span></p>
                                                    {
                                                        _.map(v1.followQuestion, (followQue, i) => {
                                                            return <div className="padding-left-30" key={i}>
                                                                <p>{followQue.name} </p>
                                                                <ul className="increment-questions"><li className="ques-gray">{followQue.answerType.type}</li></ul>

                                                                {followQue.answerType.id.toString() !== '7' &&
                                                                    _.map(followQue.answer, (followAns, i) => {
                                                                        return <div key={i}>
                                                                            <p><span className="icon-add-more"></span><span className="followtext">{followAns.name} </span></p>

                                                                        </div>
                                                                    })}
                                                                {followQue.answerType.id.toString() === '7' && followQue.sliderConfiguration && followQue.sliderConfiguration.length &&
                                                                    <div>
                                                                        <p>Min:{followQue.sliderConfiguration[0].data} </p>
                                                                        <p>{followQue.sliderConfiguration[0].value}</p>
                                                                        <p>Mid:{followQue.sliderConfiguration[1].data}</p>
                                                                        <p>{followQue.sliderConfiguration[1].value}</p>
                                                                        <p>Max:{followQue.sliderConfiguration[2].data} </p>
                                                                        <p>{followQue.sliderConfiguration[2].value}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        })}
                                                </div>
                                            })}
                                            {v.answerType.id.toString() === '7' && v.sliderConfiguration && v.sliderConfiguration.length &&
                                                <div>
                                                    <p>Min:{v.sliderConfiguration[0].data} </p>
                                                    <p>{v.sliderConfiguration[0].value}</p>
                                                    <p>Mid:{v.sliderConfiguration[1].data}</p>
                                                    <p>{v.sliderConfiguration[1].value}</p>
                                                    <p>Max:{v.sliderConfiguration[2].data}</p>
                                                    <p>{v.sliderConfiguration[2].value}</p>
                                                </div>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                    <div role="tabpanel" className="tab-pane active scras">

                        {_.map(this.state.linkedQuestions && this.state.linkedQuestions, (v, i) => {
                            if (this.state.editQuestion && this.state.editQuestion.id === v.id) {
                                return
                            }
                            return <div key={i} className="input-group input-field your-question">
                                <div className="addingQuestions">
                                    <div className='tickmark-after crap' onClick={this.removeQuestions} data-value={v.id} >
                                        <span className="icon-tick"></span>
                                    </div>
                                    <div className="yourquestion saved-ques" >
                                        <div >
                                            <p>{v.name}</p>
                                            <ul className="increment-questions">
                                                <li className="ques-gray">{v.answerType.type}</li>
                                            </ul>
                                            {v.answerType.id.toString() !== '7' && _.map(v.answer, (v1, i) => {
                                                return <div className="padding-left-30" key={i}>
                                                    <p><span className="icon-add-more"></span><span className="followtext">{v1.name}</span></p>
                                                    {
                                                        _.map(v1.followQuestion, (followQue, i) => {
                                                            return <div className="padding-left-30" key={i}>
                                                                <p>{followQue.name} </p>
                                                                <ul className="increment-questions"><li className="ques-gray">{followQue.answerType.type}</li></ul>

                                                                {followQue.answerType.id.toString() !== '7' &&
                                                                    _.map(followQue.answer, (followAns, i) => {
                                                                        return <div key={i}>
                                                                            <p><span className="icon-add-more"></span><span className="followtext">{followAns.name} </span></p>

                                                                        </div>
                                                                    })}
                                                                {followQue.answerType.id.toString() === '7' && followQue.sliderConfiguration && followQue.sliderConfiguration.length &&
                                                                    <div>
                                                                        <p>Min:{followQue.sliderConfiguration[0].data} </p>
                                                                        <p>{followQue.sliderConfiguration[0].value}</p>
                                                                        <p>Mid:{followQue.sliderConfiguration[1].data}</p>
                                                                        <p>{followQue.sliderConfiguration[1].value}</p>
                                                                        <p>Max:{followQue.sliderConfiguration[2].data}</p>
                                                                        <p>{followQue.sliderConfiguration[2].value}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        })}
                                                </div>
                                            })}
                                            {v.answerType.id.toString() === '7' && v.sliderConfiguration && v.sliderConfiguration.length &&
                                                <div>
                                                    <p>Min:{v.sliderConfiguration[0].data} </p>
                                                    <p>{v.sliderConfiguration[0].value}</p>
                                                    <p>Mid:{v.sliderConfiguration[1].data}</p>
                                                    <p>{v.sliderConfiguration[1].value}</p>
                                                    <p>Max:{v.sliderConfiguration[2].data}</p>
                                                    <p>{v.sliderConfiguration[2].value}</p>
                                                </div>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                <div> {this.state.showModal ? <ModalDialogCommon message="Please select at least 1 question to update." action={this.closebox} /> : ""}</div>
                <div> {this.state.conformationModalMessage ? <ModalDialogCommon message={this.state.conformationModalMessage} cancel="true" action2={this.closebox} action={this.onConfirm} /> : ""}</div>
            </div>

        );
    }
});


let mapStateToProps = (state) => {

    let SurveyList = _.filter(state.Questionnaire.QuestionnaireUnique, { survey: true });
    return {
        UserData: state.User,
        uniqe: state.Questionnaire.PatientGetAllUniqueQuestion,
        publishQuestionSelected: [],
        FacilitiesDetails: state.Facilites,
        RemovedPublishedQuestion: [],

    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AddOptionalQuestions));



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/add-optional-questions.js
 **/